import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

const Pricing: React.FC = () => {
  return (
    <section className="py-24 bg-navy relative" id="pricing">
      <div className="2xl:px-52 px-0">
        <div className="lg:px-24 px-6 md:px-8">
          <div className="text-center mb-16">
            <h2 className="font-bold text-4xl md:text-6xl text-white mb-6">
              Simple, Transparent Pricing.
            </h2>
            <p className="text-xl text-muted">No hidden fees. Just guaranteed growth.</p>
          </div>

          <div className="w-full">
            {/* Main Featured Card - The Viral Package */}
            <motion.div 
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="bg-zinc-900 border-2 border-primary rounded-[2.5rem] p-8 md:p-12 relative shadow-[0_0_50px_rgba(244,63,94,0.15)] overflow-hidden"
            >
                <div className="absolute top-0 right-0 bg-primary text-white font-bold py-1.5 px-4 text-xs sm:text-base sm:py-2 sm:px-8 rounded-bl-2xl">
                    MOST POPULAR
                </div>

                <div className="flex flex-col md:flex-row gap-12">
                    {/* Left Info */}
                    <div className="flex-1">
                        <h3 className="font-bold text-3xl text-white mb-2">The Viral Package</h3>
                        <p className="text-muted mb-8">Complete domination for your game.</p>
                        
                        <div className="mb-8">
                            <span className="text-6xl md:text-7xl font-bold text-white">$1,900</span>
                            <span className="text-muted text-xl">/month</span>
                        </div>

                        <a 
                            href="https://discord.gg/sy5k53rkz4" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="inline-block w-full md:w-auto text-center bg-primary hover:bg-primary-hover text-white font-bold py-4 px-10 rounded-2xl transition-all duration-300 shadow-[0_4px_20px_rgba(244,63,94,0.4)] hover:shadow-[0_6px_30px_rgba(244,63,94,0.6)] hover:translate-y-[-2px]"
                        >
                            Start Growing Today
                        </a>
                        <p className="text-accent text-sm mt-4 text-center md:text-left">Guaranteed 250k Views or Money Back</p>
                    </div>

                    {/* Right Features */}
                    <div className="flex-1">
                        <h4 className="text-sm font-bold text-muted uppercase tracking-widest mb-6">What's Included</h4>
                        <ul className="space-y-4">
                            {[
                                '30 Unique Videos / Month',
                                'Distribution to TikTok, Reels, Shorts',
                                'Full Account Management',
                                'Community Engagement',
                                'View Count Guarantee',
                                'Monthly Performance Reports',
                                'Hook Psychology Optimization'
                            ].map((feature, i) => (
                                <li key={i} className="flex items-center gap-3">
                                    <Check className="w-5 h-5 text-primary flex-shrink-0" />
                                    <span className="text-white">{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </motion.div>

            {/* Bottom Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                 <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 text-center"
                 >
                    <h4 className="font-bold text-white mb-2">Results Focused</h4>
                    <p className="text-muted text-sm">We don't just post; we aim for viral hits every time.</p>
                 </motion.div>
                 <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 text-center"
                 >
                    <h4 className="font-bold text-white mb-2">No Contracts</h4>
                    <p className="text-muted text-sm">Pause or cancel your subscription anytime.</p>
                 </motion.div>
                 <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6 text-center"
                 >
                    <h4 className="font-bold text-white mb-2">Expert Team</h4>
                    <p className="text-muted text-sm">Content made by gamers, for gamers.</p>
                 </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
